<template>

</template>

<script>
export default {
  name: "UserPicker",
  components: {},
  props:{
    value:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

   .name-text{
      font-size: 14px;
      color: #2F3030;
      line-height: 28px;
    }
</style>